import {Modal, ModalProps, Space, Table} from "antd";

interface OrderResultListModal extends ModalProps{
    records: Array<any>
}
function OrderResultListModal(props:OrderResultListModal){
    const {records=[], ...otherProps} = props;

    const columns:Array<any> = [
        {
            dataIndex: 'code',
            title: '订单号',
        },
        {
            dataIndex: 'amount',
            title: '订单金额'
        },
        {
            dataIndex: 'operation',
            title: '操作',
            render(v:any, record:any){
                let orderType;
                debugger;
                switch (record.type) {
                    case 'preOrder':
                        orderType = 'presale'
                        break;
                    case 'outStockOrder':
                        orderType = 'stockout'
                        break;
                    case 'salesOrder':
                        orderType = 'sales'
                        break;
                    case 'consignmentOrder':
                        orderType = 'consign'
                        break;
                }
                return <Space>
                    <a href={`/order/${orderType}/detail/${record.id}`} target={"_blank"}>编辑提交</a>
                </Space>
            }
        }
    ]

    return <Modal {...otherProps} width={600} onOk={props.onCancel} title={'订单信息'} footer={null}>
        <Table dataSource={records} columns={columns} rowKey={(record)=>`${record.type}-${record.id}`} pagination={false}/>
    </Modal>
}


export default OrderResultListModal;